<div class="flex-middle">
    <div class="no-wrap flex flex-middle">
        <!-- 'from' for configurable or bundle -->
        <!-- @if (isFromPrice) {
    <span class="inline-block p1 col-12 m-r-1 va-m">{{'from' | translate}}</span>
    } -->
        @switch (!!mapPrice) {
        @case (true) {
        <price class="h3 col-1 inline-block line-through va-m"
               [value]="orgPrice || price"></price>
        <div class="h3 col-11 inline-block va-m m-l-2">{{ 'See price in cart' | translate }}</div>
        }

        @default {
        <price class="h2 col-1 inline-block va-m"
               [value]="price"></price>
        @if (orgPrice) {
        <price class="h3 col-11 inline-block line-through va-m m-l-2"
               [value]="orgPrice"></price>
        }
        }
        }

    </div>
    @if(soldBy){
    <p class="p2"><span class="m-r-1">{{'Sold by' | translate}}:</span><span
              class="col-11 lowercase-s lowercase-m">{{soldBy}}</span></p>
    }
</div>
